import type {ExtractPropsWithoutRef} from '@/types';

import {forwardRef} from 'react';

import {Button} from '@/components/FloatingActionButton/components/Button';
import {LayerPortal} from '@/components/LayerPortal';
import {useFloatingActionButtonMargin} from '@/hooks';

type Props = ExtractPropsWithoutRef<typeof Button> & {
  width?: React.CSSProperties['width'];
};

export const FloatingActionButton = forwardRef<HTMLButtonElement, Props>(
  function FloatingActionButton(
    {width = 'max-content', style, ...restProps},
    ref
  ) {
    const margin = useFloatingActionButtonMargin();

    return (
      <LayerPortal>
        <Button
          ref={ref}
          variant="neutral"
          style={{
            ...style,
            '--width': width,
            '--margin': `${margin}px`,
          }}
          {...restProps}
        />
      </LayerPortal>
    );
  }
);
